import { defineComponent as Et, watchEffect as de, ref as v, toRef as m, computed as u, watch as ue, provide as zt, h as o, Transition as Ut, withDirectives as Bt } from "vue";
import { strictParse as I } from "./ghl-ui.es964.js";
import { uniCalendarValidation as Mt, dualCalendarValidation as jt } from "./ghl-ui.es965.js";
import { datePickerInjectionKey as Nt } from "./ghl-ui.es966.js";
import _t from "./ghl-ui.es967.js";
import qt from "./ghl-ui.es968.js";
import Ht from "./ghl-ui.es969.js";
import Kt from "./ghl-ui.es970.js";
import Yt from "./ghl-ui.es971.js";
import $t from "./ghl-ui.es972.js";
import Wt from "./ghl-ui.es973.js";
import { warnOnce as Lt, warn as Qt } from "./ghl-ui.es853.js";
import Gt from "./ghl-ui.es919.js";
import Jt from "./ghl-ui.es870.js";
import Xt from "./ghl-ui.es854.js";
import se from "./ghl-ui.es712.js";
import ve from "./ghl-ui.es855.js";
import { useThemeClass as ce } from "./ghl-ui.es857.js";
import { createKey as me } from "./ghl-ui.es384.js";
import Zt from "./ghl-ui.es713.js";
import fe from "./ghl-ui.es182.js";
import { resolveSlot as K } from "./ghl-ui.es860.js";
import Y from "./ghl-ui.es862.js";
import ea from "./ghl-ui.es718.js";
import ta from "./ghl-ui.es974.js";
import { markEventEffectPerformed as he } from "./ghl-ui.es975.js";
import { getPreciseEventTarget as aa } from "./ghl-ui.es875.js";
import O from "./ghl-ui.es976.js";
import $ from "./ghl-ui.es977.js";
import W from "./ghl-ui.es978.js";
import { happensIn as na } from "./ghl-ui.es944.js";
import ra from "./ghl-ui.es979.js";
import ge from "./ghl-ui.es980.js";
import { call as p } from "./ghl-ui.es876.js";
import { useAdjustedTo as L } from "./ghl-ui.es877.js";
import ia from "./ghl-ui.es878.js";
import la from "./ghl-ui.es879.js";
import oa from "./ghl-ui.es880.js";
const da = Object.assign(Object.assign({}, ve.props), {
  to: L.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  updateValueOnClose: Boolean,
  defaultValue: [Number, Array],
  defaultFormattedValue: [String, Array],
  defaultTime: [Number, String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: [Number, Array],
  formattedValue: [String, Array],
  size: String,
  type: {
    type: String,
    default: "date"
  },
  valueFormat: String,
  separator: String,
  placeholder: String,
  startPlaceholder: String,
  endPlaceholder: String,
  format: String,
  dateFormat: String,
  timeFormat: String,
  actions: Array,
  shortcuts: Object,
  isDateDisabled: Function,
  isTimeDisabled: Function,
  show: {
    type: Boolean,
    default: void 0
  },
  panel: Boolean,
  ranges: Object,
  firstDayOfWeek: Number,
  inputReadonly: Boolean,
  closeOnSelect: Boolean,
  status: String,
  timePickerProps: [Object, Array],
  onClear: Function,
  onConfirm: Function,
  defaultCalendarStartTime: Number,
  defaultCalendarEndTime: Number,
  bindCalendarMonths: Boolean,
  monthFormat: {
    type: String,
    default: "M"
  },
  yearFormat: {
    type: String,
    default: "y"
  },
  quarterFormat: {
    type: String,
    default: "'Q'Q"
  },
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onNextMonth: Function,
  onPrevMonth: Function,
  onNextYear: Function,
  onPrevYear: Function,
  // deprecated
  onChange: [Function, Array]
}), Wa = Et({
  name: "DatePicker",
  props: da,
  setup(t, {
    slots: k
  }) {
    var d;
    process.env.NODE_ENV !== "production" && de(() => {
      t.onChange !== void 0 && Lt("date-picker", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      localeRef: r,
      dateLocaleRef: f
    } = Gt("DatePicker"), C = Jt(t), {
      mergedSizeRef: z,
      mergedDisabledRef: l,
      mergedStatusRef: pe
    } = C, {
      mergedComponentPropsRef: M,
      mergedClsPrefixRef: j,
      mergedBorderedRef: ye,
      namespaceRef: Ce,
      inlineThemeDisabled: U
    } = Xt(t), Q = v(null), G = v(null), S = v(null), J = v(!1), Pe = m(t, "show"), h = se(Pe, J), g = u(() => ({
      locale: f.value.locale
    })), P = u(() => {
      const {
        format: e
      } = t;
      if (e)
        return e;
      switch (t.type) {
        case "date":
        case "daterange":
          return r.value.dateFormat;
        case "datetime":
        case "datetimerange":
          return r.value.dateTimeFormat;
        case "year":
        case "yearrange":
          return r.value.yearTypeFormat;
        case "month":
        case "monthrange":
          return r.value.monthTypeFormat;
        case "quarter":
        case "quarterrange":
          return r.value.quarterFormat;
        case "week":
          return r.value.weekFormat;
      }
    }), N = u(() => {
      var e;
      return (e = t.valueFormat) !== null && e !== void 0 ? e : P.value;
    });
    function X(e) {
      if (e === null)
        return null;
      const {
        value: a
      } = N, {
        value: n
      } = g;
      return Array.isArray(e) ? [I(e[0], a, /* @__PURE__ */ new Date(), n).getTime(), I(e[1], a, /* @__PURE__ */ new Date(), n).getTime()] : I(e, a, /* @__PURE__ */ new Date(), n).getTime();
    }
    const {
      defaultFormattedValue: Z,
      defaultValue: Te
    } = t, _ = v((d = Z !== void 0 ? X(Z) : Te) !== null && d !== void 0 ? d : null), Fe = u(() => {
      const {
        formattedValue: e
      } = t;
      return e !== void 0 ? X(e) : t.value;
    }), ee = se(Fe, _), s = v(null);
    de(() => {
      s.value = ee.value;
    });
    const x = v(""), A = v(""), E = v(""), B = ve("DatePicker", "-date-picker", Wt, ta, t, j), Se = u(() => {
      var e, a;
      return ((a = (e = M == null ? void 0 : M.value) === null || e === void 0 ? void 0 : e.DatePicker) === null || a === void 0 ? void 0 : a.timePickerSize) || "small";
    }), te = u(() => ["daterange", "datetimerange", "monthrange", "quarterrange", "yearrange"].includes(t.type)), Re = u(() => {
      const {
        placeholder: e
      } = t;
      if (e === void 0) {
        const {
          type: a
        } = t;
        switch (a) {
          case "date":
            return r.value.datePlaceholder;
          case "datetime":
            return r.value.datetimePlaceholder;
          case "month":
            return r.value.monthPlaceholder;
          case "year":
            return r.value.yearPlaceholder;
          case "quarter":
            return r.value.quarterPlaceholder;
          case "week":
            return r.value.weekPlaceholder;
          default:
            return "";
        }
      } else
        return e;
    }), be = u(() => t.startPlaceholder === void 0 ? t.type === "daterange" ? r.value.startDatePlaceholder : t.type === "datetimerange" ? r.value.startDatetimePlaceholder : t.type === "monthrange" ? r.value.startMonthPlaceholder : "" : t.startPlaceholder), Ve = u(() => t.endPlaceholder === void 0 ? t.type === "daterange" ? r.value.endDatePlaceholder : t.type === "datetimerange" ? r.value.endDatetimePlaceholder : t.type === "monthrange" ? r.value.endMonthPlaceholder : "" : t.endPlaceholder), we = u(() => {
      const {
        actions: e,
        type: a,
        clearable: n
      } = t;
      if (e === null)
        return [];
      if (e !== void 0)
        return e;
      const i = n ? ["clear"] : [];
      switch (a) {
        case "date":
        case "week":
          return i.push("now"), i;
        case "datetime":
          return i.push("now", "confirm"), i;
        case "daterange":
          return i.push("confirm"), i;
        case "datetimerange":
          return i.push("confirm"), i;
        case "month":
          return i.push("now", "confirm"), i;
        case "year":
          return i.push("now"), i;
        case "quarter":
          return i.push("now", "confirm"), i;
        case "monthrange":
        case "yearrange":
        case "quarterrange":
          return i.push("confirm"), i;
        default: {
          Qt("date-picker", "The type is wrong, n-date-picker's type only supports `date`, `datetime`, `daterange` and `datetimerange`.");
          break;
        }
      }
    });
    function De(e) {
      if (e === null)
        return null;
      if (Array.isArray(e)) {
        const {
          value: a
        } = N, {
          value: n
        } = g;
        return [O(e[0], a, n), O(e[1], a, g.value)];
      } else
        return O(e, N.value, g.value);
    }
    function Ie(e) {
      s.value = e;
    }
    function Oe(e, a) {
      const {
        "onUpdate:formattedValue": n,
        onUpdateFormattedValue: i
      } = t;
      n && p(n, e, a), i && p(i, e, a);
    }
    function R(e, a) {
      const {
        "onUpdate:value": n,
        onUpdateValue: i,
        onChange: y
      } = t, {
        nTriggerFormChange: T,
        nTriggerFormInput: F
      } = C, c = De(e);
      a.doConfirm && ke(e, c), i && p(i, e, c), n && p(n, e, c), y && p(y, e, c), _.value = e, Oe(c, e), T(), F();
    }
    function ae() {
      const {
        onClear: e
      } = t;
      e == null || e();
    }
    function ke(e, a) {
      const {
        onConfirm: n
      } = t;
      n && n(e, a);
    }
    function xe(e) {
      const {
        onFocus: a
      } = t, {
        nTriggerFormFocus: n
      } = C;
      a && p(a, e), n();
    }
    function Ae(e) {
      const {
        onBlur: a
      } = t, {
        nTriggerFormBlur: n
      } = C;
      a && p(a, e), n();
    }
    function q(e) {
      const {
        "onUpdate:show": a,
        onUpdateShow: n
      } = t;
      a && p(a, e), n && p(n, e), J.value = e;
    }
    function Ee(e) {
      e.key === "Escape" && h.value && (he(e), V({
        returnFocus: !0
      }));
    }
    function ze(e) {
      e.key === "Escape" && h.value && he(e);
    }
    function Ue() {
      var e;
      q(!1), (e = S.value) === null || e === void 0 || e.deactivate(), ae();
    }
    function Be() {
      var e;
      (e = S.value) === null || e === void 0 || e.deactivate(), ae();
    }
    function Me() {
      V({
        returnFocus: !0
      });
    }
    function je(e) {
      var a;
      h.value && !(!((a = G.value) === null || a === void 0) && a.contains(aa(e))) && V({
        returnFocus: !1
      });
    }
    function Ne(e) {
      V({
        returnFocus: !0,
        disableUpdateOnClose: e
      });
    }
    function _e(e, a) {
      a ? R(e, {
        doConfirm: !1
      }) : Ie(e);
    }
    function ne() {
      const e = s.value;
      R(Array.isArray(e) ? [e[0], e[1]] : e, {
        doConfirm: !0
      });
    }
    function b() {
      const {
        value: e
      } = s;
      te.value ? (Array.isArray(e) || e === null) && He(e) : Array.isArray(e) || qe(e);
    }
    function qe(e) {
      e === null ? x.value = "" : x.value = O(e, P.value, g.value);
    }
    function He(e) {
      if (e === null)
        A.value = "", E.value = "";
      else {
        const a = g.value;
        A.value = O(e[0], P.value, a), E.value = O(e[1], P.value, a);
      }
    }
    function Ke() {
      h.value || re();
    }
    function Ye(e) {
      var a;
      !((a = Q.value) === null || a === void 0) && a.$el.contains(e.relatedTarget) || (Ae(e), b(), V({
        returnFocus: !1
      }));
    }
    function $e() {
      l.value || (b(), V({
        returnFocus: !1
      }));
    }
    function We(e) {
      if (e === "") {
        R(null, {
          doConfirm: !1
        }), s.value = null, x.value = "";
        return;
      }
      const a = I(e, P.value, /* @__PURE__ */ new Date(), g.value);
      $(a) ? (R(W(a), {
        doConfirm: !1
      }), b()) : x.value = e;
    }
    function Le(e, {
      source: a
    }) {
      if (e[0] === "" && e[1] === "") {
        R(null, {
          doConfirm: !1
        }), s.value = null, A.value = "", E.value = "";
        return;
      }
      const [n, i] = e, y = I(n, P.value, /* @__PURE__ */ new Date(), g.value), T = I(i, P.value, /* @__PURE__ */ new Date(), g.value);
      if ($(y) && $(T)) {
        let F = W(y), c = W(T);
        T < y && (a === 0 ? c = F : F = c), R([F, c], {
          doConfirm: !1
        }), b();
      } else
        [A.value, E.value] = e;
    }
    function Qe(e) {
      l.value || na(e, "clear") || h.value || re();
    }
    function Ge(e) {
      l.value || xe(e);
    }
    function re() {
      l.value || h.value || q(!0);
    }
    function V({
      returnFocus: e,
      disableUpdateOnClose: a
    }) {
      var n;
      h.value && (q(!1), t.type !== "date" && t.updateValueOnClose && !a && ne(), e && ((n = S.value) === null || n === void 0 || n.focus()));
    }
    ue(s, () => {
      b();
    }), b(), ue(h, (e) => {
      e || (s.value = ee.value);
    });
    const ie = Mt(t, s), H = jt(t, s);
    zt(Nt, Object.assign(Object.assign(Object.assign({
      mergedClsPrefixRef: j,
      mergedThemeRef: B,
      timePickerSizeRef: Se,
      localeRef: r,
      dateLocaleRef: f,
      firstDayOfWeekRef: m(t, "firstDayOfWeek"),
      isDateDisabledRef: m(t, "isDateDisabled"),
      rangesRef: m(t, "ranges"),
      timePickerPropsRef: m(t, "timePickerProps"),
      closeOnSelectRef: m(t, "closeOnSelect"),
      updateValueOnCloseRef: m(t, "updateValueOnClose"),
      monthFormatRef: m(t, "monthFormat"),
      yearFormatRef: m(t, "yearFormat"),
      quarterFormatRef: m(t, "quarterFormat")
    }, ie), H), {
      datePickerSlots: k
    }));
    const Je = {
      focus: () => {
        var e;
        (e = S.value) === null || e === void 0 || e.focus();
      },
      blur: () => {
        var e;
        (e = S.value) === null || e === void 0 || e.blur();
      }
    }, le = u(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          iconColor: a,
          iconColorDisabled: n
        }
      } = B.value;
      return {
        "--n-bezier": e,
        "--n-icon-color-override": a,
        "--n-icon-color-disabled-override": n
      };
    }), w = U ? ce("date-picker-trigger", void 0, le, t) : void 0, oe = u(() => {
      const {
        type: e
      } = t, {
        common: {
          cubicBezierEaseInOut: a
        },
        self: {
          calendarTitleFontSize: n,
          calendarDaysFontSize: i,
          itemFontSize: y,
          itemTextColor: T,
          itemColorDisabled: F,
          itemColorIncluded: c,
          itemColorHover: Xe,
          itemColorActive: Ze,
          itemBorderRadius: et,
          itemTextColorDisabled: tt,
          itemTextColorActive: at,
          panelColor: nt,
          panelTextColor: rt,
          arrowColor: it,
          calendarTitleTextColor: lt,
          panelActionDividerColor: ot,
          panelHeaderDividerColor: dt,
          calendarDaysDividerColor: ut,
          panelBoxShadow: st,
          panelBorderRadius: ct,
          calendarTitleFontWeight: mt,
          panelExtraFooterPadding: ft,
          panelActionPadding: ht,
          itemSize: gt,
          itemCellWidth: vt,
          itemCellHeight: pt,
          scrollItemWidth: yt,
          scrollItemHeight: Ct,
          calendarTitlePadding: Pt,
          calendarTitleHeight: Tt,
          calendarDaysHeight: Ft,
          calendarDaysTextColor: St,
          arrowSize: Rt,
          panelHeaderPadding: bt,
          calendarDividerColor: Vt,
          calendarTitleGridTempateColumns: wt,
          iconColor: Dt,
          iconColorDisabled: It,
          scrollItemBorderRadius: Ot,
          calendarTitleColorHover: kt,
          [me("calendarLeftPadding", e)]: xt,
          [me("calendarRightPadding", e)]: At
        }
      } = B.value;
      return {
        "--n-bezier": a,
        "--n-panel-border-radius": ct,
        "--n-panel-color": nt,
        "--n-panel-box-shadow": st,
        "--n-panel-text-color": rt,
        // panel header
        "--n-panel-header-padding": bt,
        "--n-panel-header-divider-color": dt,
        // panel calendar
        "--n-calendar-left-padding": xt,
        "--n-calendar-right-padding": At,
        "--n-calendar-title-color-hover": kt,
        "--n-calendar-title-height": Tt,
        "--n-calendar-title-padding": Pt,
        "--n-calendar-title-font-size": n,
        "--n-calendar-title-font-weight": mt,
        "--n-calendar-title-text-color": lt,
        "--n-calendar-title-grid-template-columns": wt,
        "--n-calendar-days-height": Ft,
        "--n-calendar-days-divider-color": ut,
        "--n-calendar-days-font-size": i,
        "--n-calendar-days-text-color": St,
        "--n-calendar-divider-color": Vt,
        // panel action
        "--n-panel-action-padding": ht,
        "--n-panel-extra-footer-padding": ft,
        "--n-panel-action-divider-color": ot,
        // panel item
        "--n-item-font-size": y,
        "--n-item-border-radius": et,
        "--n-item-size": gt,
        "--n-item-cell-width": vt,
        "--n-item-cell-height": pt,
        "--n-item-text-color": T,
        "--n-item-color-included": c,
        "--n-item-color-disabled": F,
        "--n-item-color-hover": Xe,
        "--n-item-color-active": Ze,
        "--n-item-text-color-disabled": tt,
        "--n-item-text-color-active": at,
        // scroll item
        "--n-scroll-item-width": yt,
        "--n-scroll-item-height": Ct,
        "--n-scroll-item-border-radius": Ot,
        // panel arrow
        "--n-arrow-size": Rt,
        "--n-arrow-color": it,
        // icon in trigger
        "--n-icon-color": Dt,
        "--n-icon-color-disabled": It
      };
    }), D = U ? ce("date-picker", u(() => t.type), oe, t) : void 0;
    return Object.assign(Object.assign({}, Je), {
      mergedStatus: pe,
      mergedClsPrefix: j,
      mergedBordered: ye,
      namespace: Ce,
      uncontrolledValue: _,
      pendingValue: s,
      panelInstRef: Q,
      triggerElRef: G,
      inputInstRef: S,
      isMounted: Zt(),
      displayTime: x,
      displayStartTime: A,
      displayEndTime: E,
      mergedShow: h,
      adjustedTo: L(t),
      isRange: te,
      localizedStartPlaceholder: be,
      localizedEndPlaceholder: Ve,
      mergedSize: z,
      mergedDisabled: l,
      localizedPlacehoder: Re,
      isValueInvalid: ie.isValueInvalidRef,
      isStartValueInvalid: H.isStartValueInvalidRef,
      isEndValueInvalid: H.isEndValueInvalidRef,
      handleInputKeydown: ze,
      handleClickOutside: je,
      handleKeydown: Ee,
      handleClear: Ue,
      handlePanelClear: Be,
      handleTriggerClick: Qe,
      handleInputActivate: Ke,
      handleInputDeactivate: $e,
      handleInputFocus: Ge,
      handleInputBlur: Ye,
      handlePanelTabOut: Me,
      handlePanelClose: Ne,
      handleRangeUpdateValue: Le,
      handleSingleUpdateValue: We,
      handlePanelUpdateValue: _e,
      handlePanelConfirm: ne,
      mergedTheme: B,
      actions: we,
      triggerCssVars: U ? void 0 : le,
      triggerThemeClass: w == null ? void 0 : w.themeClass,
      triggerOnRender: w == null ? void 0 : w.onRender,
      cssVars: U ? void 0 : oe,
      themeClass: D == null ? void 0 : D.themeClass,
      onRender: D == null ? void 0 : D.onRender,
      onNextMonth: t.onNextMonth,
      onPrevMonth: t.onPrevMonth,
      onNextYear: t.onNextYear,
      onPrevYear: t.onPrevYear
    });
  },
  render() {
    const {
      clearable: t,
      triggerOnRender: k,
      mergedClsPrefix: d,
      $slots: r
    } = this, f = {
      onUpdateValue: this.handlePanelUpdateValue,
      onTabOut: this.handlePanelTabOut,
      onClose: this.handlePanelClose,
      onClear: this.handlePanelClear,
      onKeydown: this.handleKeydown,
      onConfirm: this.handlePanelConfirm,
      ref: "panelInstRef",
      value: this.pendingValue,
      active: this.mergedShow,
      actions: this.actions,
      shortcuts: this.shortcuts,
      style: this.cssVars,
      defaultTime: this.defaultTime,
      themeClass: this.themeClass,
      panel: this.panel,
      onRender: this.onRender,
      onNextMonth: this.onNextMonth,
      onPrevMonth: this.onPrevMonth,
      onNextYear: this.onNextYear,
      onPrevYear: this.onPrevYear
    }, C = () => {
      const {
        type: l
      } = this;
      return l === "datetime" ? o(_t, Object.assign({}, f, {
        defaultCalendarStartTime: this.defaultCalendarStartTime
      }), r) : l === "daterange" ? o(Kt, Object.assign({}, f, {
        defaultCalendarStartTime: this.defaultCalendarStartTime,
        defaultCalendarEndTime: this.defaultCalendarEndTime,
        bindCalendarMonths: this.bindCalendarMonths
      }), r) : l === "datetimerange" ? o(qt, Object.assign({}, f, {
        defaultCalendarStartTime: this.defaultCalendarStartTime,
        defaultCalendarEndTime: this.defaultCalendarEndTime,
        bindCalendarMonths: this.bindCalendarMonths
      }), r) : l === "month" || l === "year" || l === "quarter" ? o(Yt, Object.assign({}, f, {
        type: l,
        key: l
      })) : l === "monthrange" || l === "yearrange" || l === "quarterrange" ? o($t, Object.assign({}, f, {
        type: l
      })) : o(Ht, Object.assign({}, f, {
        type: l,
        defaultCalendarStartTime: this.defaultCalendarStartTime
      }), r);
    };
    if (this.panel)
      return C();
    k == null || k();
    const z = {
      bordered: this.mergedBordered,
      size: this.mergedSize,
      passivelyActivated: !0,
      disabled: this.mergedDisabled,
      readonly: this.inputReadonly || this.mergedDisabled,
      clearable: t,
      onClear: this.handleClear,
      onClick: this.handleTriggerClick,
      onKeydown: this.handleInputKeydown,
      onActivate: this.handleInputActivate,
      onDeactivate: this.handleInputDeactivate,
      onFocus: this.handleInputFocus,
      onBlur: this.handleInputBlur
    };
    return o("div", {
      ref: "triggerElRef",
      class: [`${d}-date-picker`, this.mergedDisabled && `${d}-date-picker--disabled`, this.isRange && `${d}-date-picker--range`, this.triggerThemeClass],
      style: this.triggerCssVars,
      onKeydown: this.handleKeydown
    }, o(ia, null, {
      default: () => [o(la, null, {
        default: () => this.isRange ? o(fe, Object.assign({
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: [this.displayStartTime, this.displayEndTime],
          placeholder: [this.localizedStartPlaceholder, this.localizedEndPlaceholder],
          textDecoration: [this.isStartValueInvalid ? "line-through" : "", this.isEndValueInvalid ? "line-through" : ""],
          pair: !0,
          onUpdateValue: this.handleRangeUpdateValue,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          internalForceFocus: this.mergedShow,
          internalDeactivateOnEnter: !0
        }, z), {
          separator: () => this.separator === void 0 ? K(r.separator, () => [o(Y, {
            clsPrefix: d,
            class: `${d}-date-picker-icon`
          }, {
            default: () => o(ra, null)
          })]) : this.separator,
          [t ? "clear-icon-placeholder" : "suffix"]: () => K(r["date-icon"], () => [o(Y, {
            clsPrefix: d,
            class: `${d}-date-picker-icon`
          }, {
            default: () => o(ge, null)
          })])
        }) : o(fe, Object.assign({
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: this.displayTime,
          placeholder: this.localizedPlacehoder,
          textDecoration: this.isValueInvalid && !this.isRange ? "line-through" : "",
          onUpdateValue: this.handleSingleUpdateValue,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          internalForceFocus: this.mergedShow,
          internalDeactivateOnEnter: !0
        }, z), {
          [t ? "clear-icon-placeholder" : "suffix"]: () => o(Y, {
            clsPrefix: d,
            class: `${d}-date-picker-icon`
          }, {
            default: () => K(r["date-icon"], () => [o(ge, null)])
          })
        })
      }), o(oa, {
        show: this.mergedShow,
        containerClass: this.namespace,
        to: this.adjustedTo,
        teleportDisabled: this.adjustedTo === L.tdkey,
        placement: this.placement
      }, {
        default: () => o(Ut, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => this.mergedShow ? Bt(C(), [[ea, this.handleClickOutside, void 0, {
            capture: !0
          }]]) : null
        })
      })]
    }));
  }
});
export {
  da as datePickerProps,
  Wa as default
};
